import { configureHooks } from '../providers';
import { useFilterRequest } from './application/FilterRequest';

export const hooks = configureHooks({
    filterRequest: { hook: useFilterRequest }
});

export const useHook = hooks.useHook;
